import {
  SELECT_ALL, CLEAR_SELECTION, TOGGLE_SELECTED_ITEM, TOGGLE_UNSELECTED_ITEM
} from '../actions/types';
import { updateItemSelection } from '../utils';

const INITIAL_STATE = {
  isSelectAll: false,
  selectedItems: [],
  unselectedItems: [],
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SELECT_ALL:
      return {
        ...state, isSelectAll: true, selectedItems: [], unselectedItems: []
      };

    case CLEAR_SELECTION:
      return {
        ...state, isSelectAll: false, selectedItems: [], unselectedItems: []
      };

    case TOGGLE_SELECTED_ITEM:
      return {
        ...state,
        selectedItems: updateItemSelection(
          state.selectedItems,
          action.payload.item,
          action.payload.force
        )
      };

    case TOGGLE_UNSELECTED_ITEM:
      return {
        ...state,
        unselectedItems: updateItemSelection(
          state.unselectedItems,
          action.payload.item,
          action.payload.force
        )
      };

    default:
      return { ...state };
  }
}
